module.exports = __webpack_public_path__ + "assets/img/4.2a77da55.webp";